'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["editor", "eventKey"],
  _excluded2 = ["targetCell"];
import PropTypes from 'prop-types';
import { useState, useCallback, useEffect, useRef } from 'react';
import TableCellFloatyPopoverBody from 'rich-text-lib/components/table/TableCellFloatyPopoverBody';
import SimpleFloaty from './SimpleFloaty';
import { offset } from '@floating-ui/react';
import { getTableCellMergeSplitProperties } from '../hstable2/util';
import { useTinyMcePopoverLifecycle } from '../hooks/useTinyMcePopoverLifecycle';
import { jsx as _jsx } from "react/jsx-runtime";
const propTypes = {
  editor: PropTypes.object.isRequired,
  eventKey: PropTypes.string.isRequired
};
function TableCellPopoverManager(props) {
  const {
      editor,
      eventKey
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const [target, setTarget] = useState(null);
  const [cellProperties, setCellProperties] = useState({});
  const lastTarget = useRef(target);
  useEffect(() => {
    lastTarget.current = target;
  });
  const handleRemove = useCallback(() => {
    if (lastTarget.current) {
      setTarget(null);
    }
  }, []);
  const handleNodeChange = useCallback(({
    element: tableCellNodes
  }) => {
    if (!tableCellNodes) {
      handleRemove();
      return;
    }
    const _getTableCellMergeSpl = getTableCellMergeSplitProperties(editor, tableCellNodes),
      {
        targetCell
      } = _getTableCellMergeSpl,
      restCellProperties = _objectWithoutPropertiesLoose(_getTableCellMergeSpl, _excluded2);
    if (lastTarget.current !== targetCell) {
      setTarget(null);
      setTarget(targetCell);
    }
    setCellProperties(restCellProperties);
  }, [editor, handleRemove, lastTarget]);
  useTinyMcePopoverLifecycle({
    editor,
    onRemove: handleRemove,
    onNodeChange: handleNodeChange,
    eventKey
  });
  if (!target) return null;

  // Custom middleware to detect intersection with canvas-toolbar
  const hideOnToolbarIntersection = {
    name: 'hideOnToolbarIntersection',
    fn: ({
      elements
    }) => {
      const canvasToolbar = document.querySelector('[data-test-id="canvas-toolbar"]');
      if (!canvasToolbar || !editor.settings.inline) {
        return {};
      }
      const toolbarRect = canvasToolbar.getBoundingClientRect();
      const referenceRect = elements.reference.getBoundingClientRect();

      // Check if reference element intersects with canvas-toolbar
      const intersects = !(referenceRect.right < toolbarRect.left || referenceRect.left > toolbarRect.right || referenceRect.bottom < toolbarRect.top || referenceRect.top > toolbarRect.bottom);
      return {
        data: {
          shouldHide: intersects
        }
      };
    }
  };
  return /*#__PURE__*/_jsx(SimpleFloaty, {
    target: target,
    "data-test-id": "table-cell-popover",
    placement: "right-start",
    middleware: [offset(({
      rects
    }) => ({
      mainAxis: -rects.floating.width - 1
    })), hideOnToolbarIntersection],
    children: /*#__PURE__*/_jsx(TableCellFloatyPopoverBody, Object.assign({}, rest, cellProperties))
  });
}
TableCellPopoverManager.propTypes = propTypes;
export default TableCellPopoverManager;